// PostHarvestEvaluation.js

import { Box, Text, Main, Footer, Button, CheckBox, ResponsiveContext } from "grommet";
import { useState, useEffect, useContext } from "react";
import { updateStateHandler, convertDateToDisplayformat, correctTimeZone } from "../Utils/Utils";
import { UserContext } from "../../App";
import ConfirmPopupWindow from "../Base components/ConfirmPopupWindow";

// first page
import {
    getBerryAttachmentOptions,
    getSkinTextureOptions,
    getBerryTextureOptions2,
    getEatingQualityOptions2,
    getBerryColorWhiteOptions,
    getBerryColorRedOptions,
    getFirmBerriesOptions,
    getAstringencyOptions
} from "../Utils/RBGUtils";


// second page
import {
    getRachisDehydrationOptions,
    getBerryWrinkleOptions,
    getBerrySplitOptions,
    getNeckCrackOptions,
    getDecayOptions,
    getPackingMethodOptions
  } from "../Utils/RBGUtils";

// third page
import Notes from "../Base components/Notes";
import BaseCamera from "../Base components/BaseCamera";
import ExcelExport from "../Base components/ExcelExport";
import Grade from "../Base components/Grade";

import RadioWithText from "../Base components/RadioWithText";
import InputWithText from "../Base components/InputWithText";



const PostHarvestEvaluation = (props) => {
    // size of screen: small - mobile, medium ipad, large - computer
    //const size = useContext(ResponsiveContext);
    const currentUser = useContext(UserContext);

    // for the whole sheet
    let postHarvestValues = props.postHarvestValues;
    const setPostHarvestValues = props.setPostHarvestValues;
    const [init, setInit] = useState(false);
    const [displayDate, setDisplayDate] = useState('');

    const [confirmPopupOpen, setConfirmPopupOpen] = useState(false); // Confirm Popup Window
    

    // the size of the window in the begginning
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    // we use the useEffect hook to listen to the window resize event
    useEffect(() => {
        window.onresize = () => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
        };
    }, []);


    // changing the location of the title on the screen resize
    const [top, setTop] = useState(
        {
            topTitle: (window.innerWidth < 568 ? '185px' :
                window.innerWidth <= 860 ? '118px' : '90px'),

                topMain:  (window.innerWidth < 280? '340px' : 
                window.innerWidth < 305? '340px' : 
                window.innerWidth < 380? '310px' : 
                window.innerWidth < 446 ? '275px' :               
                window.innerWidth < 567 ? '275px' :     
                window.innerWidth < 645 ? '208px' :                                        
                window.innerWidth <= 860 ? '176px' : '148px')                 
        }
    );

    useEffect(() => {
        function handleResize() {
            setTop({
              topTitle: (window.innerWidth < 568 ? '185px' :
                window.innerWidth <= 860 ? '118px' : '90px'),

              topMain:  (window.innerWidth < 280? '340px' : 
                window.innerWidth < 305? '340px' : 
                window.innerWidth < 380? '310px' : 
                window.innerWidth < 446 ? '275px' :               
                window.innerWidth < 567 ? '275px' :     
                window.innerWidth < 645 ? '208px' :                                        
                window.innerWidth <= 860 ? '176px' : '148px')                                   
            })          
        }
        window.addEventListener('resize', handleResize)

        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    });

    useEffect(() => {
        if (postHarvestValues.UpdatedAt !== null && postHarvestValues.UpdatedAt !== undefined) {
            setDisplayDate(convertDateToDisplayformat(postHarvestValues.UpdatedAt));         
        }
    }, []);

    useEffect(() => {
        // const start = Date.now();
        if (props.disable) 
            return;        

        if (postHarvestValues.UpdatedAt !== null && postHarvestValues.UpdatedAt !== undefined
                && postHarvestValues.PostHarvest_ID !== null) {
            setDisplayDate(convertDateToDisplayformat(postHarvestValues.UpdatedAt));         
        }

        const interval = setInterval(() => {
            // console.log('saving !!! ', (interval) );
            // const millis = Math.round((Date.now() - start)/1000);
            // console.log('interval: '+ millis + ' sec');
            if(props.fieldEdited) {
                props.savePostHarvestHandler();
                props.setFieldEdited(false);
            }
        }, 3*60000);                         // 180000 = 3 minute (3 * 60000 ms)
        // }, 30000);      // 30 sec for debug
        return () => clearInterval(interval);

    }, [postHarvestValues, props.fieldEdited]);

    const save = async () => {
        //  console.log("in save func-n in PostHarvestEvaluation >> ");
        //  console.log('postHarvestValues >> ', postHarvestValues);
        return (await props.savePostHarvestHandler());
    };

    useEffect(() => {
        if(init){
            const saveAndSetReturnToPrev = async () => {
                const result = await save();
                if (result) {
                    props.setSuccess(true);
                    props.setNavigateAfterSuccess(true);
                } else {
                    setInit(false);
                    props.setShowError(true); // optional: trigger error message
                }
            };

            saveAndSetReturnToPrev();
        }
             
    },[init]);    

    
    // opens a popup window when the "submit" button is clicked
    const openConfirmPopupWindow = () => {
        setConfirmPopupOpen(true);
    }

    // hides the "Confirm" popup window 
    const onConfirmPopupClose = () => {
        setConfirmPopupOpen(false);    
    };

    // fires when the "Confirm" button is clicked in the "Yes" popup
    const onConfirmConfirm = () => {
        submit();
        onConfirmPopupClose();
    };

    const submit = async() => {  
        // console.log('in submit >> '); 
        // console.log('in submit StatusID >> ', postHarvestValues.StatusID); 
        // console.log('In savePreHarvestHandler postHarvestValues.postharvest_ID >> ', postHarvestValues.PostHarvestID); 
        if (postHarvestValues.StatusID !== 5) {
            updateStateHandler(setPostHarvestValues,'StatusID', 5);        
            updateStateHandler(setPostHarvestValues,'FinishedAt', correctTimeZone(new Date()));        
            updateStateHandler(setPostHarvestValues,'FinishedBy', currentUser.email);        
        }       
        setInit(true);
    };

    const title = 'POSTHARVEST EVALUATION DATA';

    // console.log('props.disable >> ', props.disable);

    // console.log('displayDate >> ', displayDate);
    return (
        <ResponsiveContext.Consumer>
        {screenSize => (
        <Box 
        //style={{ position: 'relative', top: '50px', width: "100%"}}
        > 
            <Box align="center" background="brand"
                style={{ 
                position: 'fixed',
                width: '90%',
                left: '45%',
                transform: 'translate(-45%)',                
                top: top.topTitle,
                zIndex: 10,
                }}            
            >
                <Box direction="row-responsive" justify="between"  align="end">
                    <Box >
                    <Text size="xlarge" margin="small" textAlign="center" weight="bold"  >
                    {title}&emsp;&emsp;    
                    {displayDate !== "" && <span style={{whiteSpace: "nowrap", fontWeight: "normal", fontSize: "20px"}}><strong>({displayDate})</strong></span>}
                    </Text>
                    </Box>
                </Box>                               
            </Box>
            <Main 
                style={{ 
                    position: 'absolute',
                    height: '75%',
                    top: top.topMain,
                    width: '90%',
                    left: '45%',
                    transform: 'translate(-45%)',
                    }}
                >
                <Box  ox  direction="row-responsive" justify="center" width="100%"  wrap>

                    {/* -------------------------------   column 1 ------------------------ */}
                    <Box width="275px" margin="xxsmall">   
                        <Box pad="small"  background="#Ededf9" border={{ color: '#c8b4ed', size: 'xsmall' }} margin={{bottom: "10px"}}  height="800px">
                            <RadioWithText
                                text="Berry Attachment:"
                                getOptions={getBerryAttachmentOptions}
                                initValue={postHarvestValues.BerryAttachment}
                                stateHandler={setPostHarvestValues}
                                fieldName="BerryAttachment"
                                direction="column"
                                updateGrade={props.updateGrade}
                                setFieldEdited={props.setFieldEdited}
                                disable={props.disable}
                            />
                            <RadioWithText
                                text="Skin Texture:"
                                getOptions={getSkinTextureOptions}
                                initValue={postHarvestValues.SkinTexture}
                                stateHandler={setPostHarvestValues}
                                fieldName="SkinTexture"
                                direction="column"
                                updateGrade={props.updateGrade}
                                setFieldEdited={props.setFieldEdited}
                                disable={props.disable}
                            />
                            <RadioWithText
                                text="Berry Texture:"
                                getOptions={getBerryTextureOptions2}
                                initValue={postHarvestValues.BerryTexture}
                                stateHandler={setPostHarvestValues}
                                fieldName="BerryTexture"
                                direction="column"
                                updateGrade={props.updateGrade}
                                setFieldEdited={props.setFieldEdited}
                                disable={props.disable}
                            />
                        </Box>
                    </Box>

                    {/* -------------------------------   column 2 ------------------------ */}
                    <Box width="275px" margin="xxsmall">   
                        <Box pad="small"  background="#Ededf9" border={{ color: '#c8b4ed', size: 'xsmall' }} margin={{bottom: "10px"}}  height="800px">
                            <RadioWithText
                                    text="Eating Quality:"
                                    getOptions={getEatingQualityOptions2}
                                    initValue={postHarvestValues.EatingQuality}
                                    stateHandler={setPostHarvestValues}
                                    fieldName="EatingQuality"
                                    direction="column"
                                    updateGrade={props.updateGrade}
                                    setFieldEdited={props.setFieldEdited}
                                    disable={props.disable}
                            />
                            
                            <RadioWithText
                                text="Berry Color (White):"
                                getOptions={getBerryColorWhiteOptions}
                                initValue={postHarvestValues.BerryColorW}
                                stateHandler={setPostHarvestValues}
                                fieldName="BerryColorW"
                                direction="column"
                                updateGrade={props.updateGrade}
                                setFieldEdited={props.setFieldEdited}
                                disable={props.disable}
                            />

                            <RadioWithText
                                text="Berry Color (Red/Black):"
                                getOptions={getBerryColorRedOptions}
                                initValue={postHarvestValues.BerryColorR}
                                stateHandler={setPostHarvestValues}
                                fieldName="BerryColorR"
                                direction="column"
                                updateGrade={props.updateGrade}
                                setFieldEdited={props.setFieldEdited}
                                disable={props.disable}
                            />
                        </Box>
                    </Box>

                    {/* -------------------------------   column 3 ------------------------ */}
                    <Box width="275px" margin="xxsmall">   
                        <Box pad="small"  background="#Ededf9" border={{ color: '#c8b4ed', size: 'xsmall' }} margin={{bottom: "10px"}}  height="800px">
                            <RadioWithText
                                text="Firm Berries:"
                                getOptions={getFirmBerriesOptions}
                                initValue={postHarvestValues.FirmBerries}
                                stateHandler={setPostHarvestValues}
                                fieldName="FirmBerries"
                                direction="column"
                                updateGrade={props.updateGrade}
                                setFieldEdited={props.setFieldEdited}
                                disable={props.disable}
                            />                            
                            <RadioWithText
                                text="Astringency:"
                                getOptions={getAstringencyOptions}
                                initValue={postHarvestValues.Astringency}
                                stateHandler={setPostHarvestValues}
                                fieldName="Astringency"
                                direction="column"
                                updateGrade={props.updateGrade}
                                setFieldEdited={props.setFieldEdited}
                                disable={props.disable}
                            />                            
                            
                            <Box margin={{vertical: "small"}}>
                                <InputWithText
                                    number={true}
                                    text="Average Brix (5-berries)"
                                    subText=""
                                    initValue={postHarvestValues.AvgBrix}
                                    stateHandler={setPostHarvestValues}
                                    updateProgressByCheck={props.updateProgressByCheck}
                                    fieldName="AvgBrix"
                                    setFieldEdited={props.setFieldEdited}
                                    disable={props.disable}
                                    />
                            </Box>
                            <Box margin={{vertical: "small"}}>                       
                                <InputWithText
                                    number={true}
                                    text="Average Sugar/Acid Ratio (5-berries)"
                                    subText=""
                                    initValue={postHarvestValues.AvgRatio}
                                    stateHandler={setPostHarvestValues}
                                    updateProgressByCheck={props.updateProgressByCheck}
                                    fieldName="AvgRatio"
                                    setFieldEdited={props.setFieldEdited}
                                    disable={props.disable}
                                />
                            </Box>
                        </Box>
                    </Box>


                    {/* -------------------------------   column 4 ------------------------ */}
                    <Box width="275px" margin="xxsmall">   
                        <Box pad="small"  background="#Ededf9" border={{ color: '#c8b4ed', size: 'xsmall' }} margin={{bottom: "10px"}}  height="800px">
                            <RadioWithText
                                text="Rachis Dehydration:"
                                getOptions={getRachisDehydrationOptions}
                                initValue={postHarvestValues.RachisDehydration}
                                stateHandler={setPostHarvestValues}
                                fieldName="RachisDehydration"
                                direction="column"
                                updateGrade={props.updateGrade}
                                setFieldEdited={props.setFieldEdited} 
                                disable={props.disable}
                            />
                            <RadioWithText
                                text="Berry Wrinkle:"
                                getOptions={getBerryWrinkleOptions}
                                initValue={postHarvestValues.BerryWrinkle}
                                stateHandler={setPostHarvestValues}
                                fieldName="BerryWrinkle"
                                direction="column"
                                updateGrade={props.updateGrade}
                                setFieldEdited={props.setFieldEdited} 
                                disable={props.disable}
                            />
                            <RadioWithText
                                text="Berry Split:"
                                getOptions={getBerrySplitOptions}
                                initValue={postHarvestValues.BerrySplit}
                                stateHandler={setPostHarvestValues}
                                fieldName="BerrySplit"
                                direction="column"
                                updateGrade={props.updateGrade}
                                setFieldEdited={props.setFieldEdited} 
                                disable={props.disable}
                            />
                            <RadioWithText
                                text="Decay:"
                                getOptions={getDecayOptions}
                                initValue={postHarvestValues.Decay}
                                stateHandler={setPostHarvestValues}
                                fieldName="Decay"
                                direction="column"
                                updateGrade={props.updateGrade}
                                setFieldEdited={props.setFieldEdited} 
                                disable={props.disable}
                            />                              
                        </Box>
                    </Box>

                    {/* -------------------------------   column 5 ------------------------ */}
                    <Box width="275px" margin="xxsmall"> 
                        <Box pad="small"  background="#Ededf9" border={{ color: '#c8b4ed', size: 'xsmall' }} margin={{bottom: "10px"}}  height="800px">
                            <RadioWithText
                                text="Neck Crack:"
                                getOptions={getNeckCrackOptions}
                                initValue={postHarvestValues.NeckCrack}
                                stateHandler={setPostHarvestValues}
                                fieldName="NeckCrack"
                                direction="column"
                                updateGrade={props.updateGrade}
                                setFieldEdited={props.setFieldEdited} 
                                disable={props.disable}
                            />                          
                            <InputWithText 
                                number={true}
                                text="Shelf Life- Number of days at room temp"
                                smlText="Following cold storage keep berry at room temp and check how many days bunch keeps fresh"
                                subText="Days"
                                initValue={postHarvestValues.ShelfLife}
                                stateHandler={setPostHarvestValues}
                                updateProgressByCheck={props.updateProgressByCheck}
                                fieldName="ShelfLife"
                                setFieldEdited={props.setFieldEdited}
                                disable={props.disable}
                            />
                            <InputWithText 
                                number={true}              
                                text="Recommended Storage Period- 0.5°C (Days)"
                                smlText="If cold storage was too short/long for the variety, recommend a longer/shorter period based on your observations"
                                subText="Days"
                                initValue={postHarvestValues.ShelfLife}
                                stateHandler={setPostHarvestValues}
                                updateProgressByCheck={props.updateProgressByCheck}
                                fieldName="ShelfLife"
                                setFieldEdited={props.setFieldEdited}
                                disable={props.disable}
                            />

                            <Box >
                                <BaseCamera
                                    title="Halved Berry"
                                    stateHandler={setPostHarvestValues}
                                    initValue={postHarvestValues.HalvedBerry1}
                                    fieldName="HalvedBerry1"
                                    setFieldEdited={props.setFieldEdited} 
                                    disable={props.disable}
                                ></BaseCamera>
                                <BaseCamera
                                    title="Halved Berry"
                                    stateHandler={setPostHarvestValues}
                                    initValue={postHarvestValues.HalvedBerry2}
                                    fieldName="HalvedBerry2"
                                    setFieldEdited={props.setFieldEdited}                         
                                    disable={props.disable}
                                ></BaseCamera>
                            </Box>                            
                        </Box>
                    </Box>

                    {/* -------------------------------   column 6 ------------------------ */}
                    <Box width="275px" margin="xxsmall"> 
                        <Box background="#Ededf9" border={{ color: '#c8b4ed', size: 'xsmall' }} margin={{bottom: "10px"}}  height="800px">  
                            <Box pad="small" margin={{bottom: "10px"}}  height="590px">
                                <RadioWithText
                                    text="Packing Method:"
                                    getOptions={getPackingMethodOptions}
                                    initValue={postHarvestValues.PackingMethod}
                                    stateHandler={setPostHarvestValues}
                                    fieldName="PackingMethod"
                                    direction="column"
                                    updateGrade={props.updateGrade}
                                    setFieldEdited={props.setFieldEdited}                         
                                    disable={props.disable}
                                />
                                <Box alignSelf="start" pad={{vertical: "small"}}>
                                    <Text alignSelf="start" color="brand" size="18px">
                                    Observations And Notes
                                    </Text>
                                </Box>
                                <Box width="540px" height="200px">
                                    <Notes
                                        stateHandler={setPostHarvestValues}
                                        initValue={postHarvestValues.Notes}
                                        fieldName="Notes"
                                        setFieldEdited={props.setFieldEdited}                         
                                        disable={props.disable}>                                
                                    </Notes>
                                </Box>

                            {/* <ExcelExport data={postHarvestValues} name='Postharvest'></ExcelExport>*/}
                            {/* <CheckBox
                            checked={
                                postHarvestValues.Variety ? postHarvestValues.Variety : false
                            }
                            label="Select as Variety"
                            onChange={(event) => {
                                updateStateHandler(
                                setPostHarvestValues,
                                "Variety",
                                event.target.checked
                                );
                            }}
                            /> */}
                            </Box>

                            <Box background="#Ededf9" margin={{bottom: "10px"}}  height="300px">
                            <Grade 
                                grade={props.grade} 
                                eliminateRange={{min: 0, max: 34}} 
                                secondChanceRange={{min: 35, max: 44}}
                                commercialPointsRange={{min: 45, max: 65}}
                             ></Grade>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                {confirmPopupOpen && (
                    <ConfirmPopupWindow
                        msg={
                            "This evaluation will be finished! Are you sure you want to continue?"
                        }
                        onClose={onConfirmPopupClose}
                        onConfirm={onConfirmConfirm}
                    />
                )} 
            </Main>
            <Footer pad="medium" direction="row-responsive" justify="start"
                style={{ 
                position: 'fixed',
                width: '90%',
                bottom: 0,
                }}
            >   
                <Box >
                    <Button 
                    style={{
                        width: "170px",
                        margin: "0 auto",
                        background: "#039039",
                        border: "1px solid #039039",
                        // fontWeight: 600,
                    }}
                    label="Submit" 
                    disabled={props.disable} 
                    onClick={openConfirmPopupWindow}  primary />
                </Box>

                <Box width={screenSize === "xsmall" || "small" ? "100%" : "80%" } justify="center" >
                    <Button 
                        style={{width: "170px", margin: "0 auto"}} 
                        label="Save Draft"
                        disabled={props.disable} onClick={save} primary />
                </Box>
                {/* <Box><ExcelExport data={preHarvestValues} name='Preharvest' ></ExcelExport></Box> */}
            </Footer>
        </Box>  
      )}

      </ResponsiveContext.Consumer>

  );
};

export default PostHarvestEvaluation;